import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { IMAGES_ASSETS_URL } from '../../../constants/links';
export const GiftCardLogoAndNumber = ({ card, shouldShowInactive = false, }) => {
    const { cardStatus } = card;
    const isCardInactive = (cardStatus === null || cardStatus === void 0 ? void 0 : cardStatus.toLowerCase()) === 'inactive';
    let cardTextColor = 'primary';
    if (shouldShowInactive) {
        cardTextColor = isCardInactive ? 'inactive' : 'subtle';
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { width: 50, height: "auto", className: "sui-inline-block sui-mr-4", 
            // TODO use sui-grayscale class instead of style prop when stencil fix this class
            style: shouldShowInactive && isCardInactive
                ? { filter: 'grayscale(1)' }
                : undefined, src: `${IMAGES_ASSETS_URL}/HD_Gift.png`, alt: "Gift card logo" }),
        card.cardNumberLast4 && (React.createElement("div", null,
            React.createElement(Typography, { variant: "body-lg", color: cardTextColor },
                "**** ******** ",
                card.cardNumberLast4,
                " *******")))));
};
GiftCardLogoAndNumber.displayName = 'GiftCardLogoAndNumber';
